module.exports = __webpack_public_path__ + "static/media/arrow-right-grey-right.da88587b.svg";